import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import TrendingUpIcon from 'mdi-react/TrendingUpIcon';
import {
  _formatNumber,
  _formatBigNumber,
} from '../../../../shared/helpers/utils';
import { getDefaultChartColors } from '../../../../shared/helpers';

const CurrentProgress = function (props) {
  if (!props.facetData) return null;
  const facet = props.facetData;

  if (
	!facet.condo_coop &&
	!facet.rental &&
	!facet.multi_family &&
	!facet.single_family
  ) {
	return null;
  }

  const analysisType = props.analysisType;
  const baseURL = props.baseURL;

  function _getTypeValue(list, key, typeKey) {
	if (!list || !list.length) return 0;
	const item = list[0] || {};
	// For single-family, use count for units as well
	if (typeKey === 'single_family' && key === 'units') return item.count || 0;
	return item[key] || 0;
  }

  const condoCoop = _getTypeValue(facet.condo_coop, analysisType, 'condo_coop');
  const rental = _getTypeValue(facet.rental, analysisType, 'rental');
  const multiFamily = _getTypeValue(facet.multi_family, analysisType, 'multi_family');
  const singleFamily = _getTypeValue(facet.single_family, analysisType, 'single_family');

  const total_count = condoCoop + rental + multiFamily + singleFamily;
  if (!total_count) return null;

  const title = {
	count: 'Total Residential Projects',
	units: 'Total Residential Units',
	sq_ft: 'Total Residential Square Feet',
  };

  const qString = baseURL.split('?');
  const params =
	qString.length > 1
	  ? new URLSearchParams(qString[1])
	  : new URLSearchParams('');
  params.delete('property_type');
  const noTypeURL =
	qString[0] + (params.toString() ? '?' + params.toString() : '');

  function _appendType(url, type) {
	if (!url) return '';
	return url + (url.includes('?') ? '&' : '?') + 'property_type=' + type;
  }

  function _formatValue(v) {
	return v > 1000000 ? _formatBigNumber(v) : _formatNumber(v);
  }

  // Color palette from shared helpers
  const colors = {
	condo_coop: getDefaultChartColors[0],   // #9a12b3
	rental: getDefaultChartColors[1],       // #00b5cc
	multi_family: getDefaultChartColors[2], // #f03434
	single_family: getDefaultChartColors[3],// #e9d460
  };

  function _renderBar(value, label, typeKey) {
	if (value <= 0) return null;
	const percent = (value / total_count) * 100;
	const minWidth = percent < 10 ? '10%' : percent + '%';

	return (
	  <div
		key={typeKey}
		style={{
		  width: minWidth,
		  backgroundColor: colors[typeKey],
		  color: '#fff',
		  textAlign: 'center',
		  padding: '8px 0',
		  display: 'inline-block',
		  transition: 'width 0.3s ease',
		}}
	  >
		<Link
		  to={_appendType(noTypeURL, typeKey)}
		  style={{
			color: '#fff',
			textDecoration: 'none',
			display: 'block',
			lineHeight: '1.1',
		  }}
		>
		  <div style={{ fontWeight: '700', fontSize: '0.95em' }}>
			{_formatValue(value)}
		  </div>
		  <div style={{ fontWeight: '300', fontSize: '0.8em', opacity: 0.9 }}>
			{label}
		  </div>
		</Link>
	  </div>
	);
  }

  return (
	<Card>
	  <CardBody className="dashboard__booking-card">
		<div className="dashboard__booking-total-container">
		  <h5 className="dashboard__booking-total-title">
			{_formatNumber(total_count)}
		  </h5>
		  <TrendingUpIcon className="dashboard__trend-icon" />
		</div>
		<h5 className="dashboard__booking-total-description">
		  {title[analysisType]}
		</h5>
		<div className="progress-wrap progress-wrap--big progress-long no-hover">
		  <p className="dashboard__booking-card-progress-label">
			Analyze by Property Type
		  </p>

		  <div
			style={{
			  display: 'flex',
			  width: '100%',
			  borderRadius: '20px',
			  overflow: 'hidden',
			}}
		  >
			{_renderBar(condoCoop, 'Condo / Co-op', 'condo_coop')}
			{_renderBar(rental, 'Rental', 'rental')}
			{_renderBar(multiFamily, 'Multi-Family', 'multi_family')}
			{_renderBar(singleFamily, 'Single-Family', 'single_family')}
		  </div>
		</div>
	  </CardBody>
	</Card>
  );
};

export default CurrentProgress;
